module.exports = __webpack_public_path__ + "static/img/patho-inflammation-medium-aTmiPuSZ.5f7f9fcf.png";